class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      currentItem: 'megamenu--current',
      visible: 'megamenu--isVisible',
      animate: 'megamenu--animate',
      active: 'megamenu--isActive',
    }

    this.megaMenuElClass = '[id^="shopify-section-sections"] #megamenu';
    this.mainNavTarget = 'header .header__menu-item.megamenu-item';
    this.megaMenuEl = null;
    this.timer = null;
    this.menuLinkHoverDuration = 100;
    this.bodyEl = document.body;
  }

  connectedCallback() {
    this.megaMenuEl = document.querySelector(this.megaMenuElClass);
    this.moveMegaMenu();
  }

  disconnectedCallback() {
    if (this.megaMenuEl) {
      this.megaMenuEl.remove();
    }
  }

  moveMegaMenu() {
    let megaMenuWrapper = document.querySelector('[id^="shopify-section-sections"] .header-wrapper');
    if (!megaMenuWrapper) {
      return;
    }

    megaMenuWrapper.insertAdjacentHTML('afterend', this.innerHTML);

    // remove original mega menu
    this.remove();
  }

  removeActiveClasses() {
    this.bodyEl.classList.remove(this.classes.animate);
    this.bodyEl.classList.remove(this.classes.active);
    this.bodyEl.classList.remove('overflow-hidden');
  }

  openMegaMenu() {
    requestAnimationFrame(() => {
      // open search menu
      document.querySelector("header header-search > header-search-toggle").open();
      document.querySelector('#megamenu').setAttribute('aria-expanded', 'true');
    });
  }

  closeMegaMenu() {
    requestAnimationFrame(() => {
      // close search menu
      document.querySelector("header header-search > header-search-toggle").close();
      document.querySelector('#megamenu').setAttribute('aria-expanded', 'false');
      document.querySelector('mega-menu-toggle').classList.remove('active');
    });
  }

  showMegaMenuItem(menuItemEl, megaMenuItemEl) {
    if (!menuItemEl) {
      return;
    }

    if (!megaMenuItemEl) {
      let megamenuId = "megamenu-" + window.handleize(menuItemEl.innerText);
      megaMenuItemEl = document.getElementById(megamenuId);
    }

    if (!megaMenuItemEl) {
      return;
    }

    // use requestAnimationFrame instead of setTimeout
    requestAnimationFrame(() => {
      // prepare menu for animation
      this.bodyEl.classList.add(this.classes.active);
      this.bodyEl.classList.add(this.classes.animate);
      this.bodyEl.classList.add('overflow-hidden');

      // show mega menu item
      setTimeout(() => {
        this.hideAllMenuItems();
        menuItemEl.classList?.add(this.classes.currentItem);
        megaMenuItemEl.classList?.add(this.classes.visible);
      }, this.menuLinkHoverDuration)
    });
  }

  hideAllMenuItems() {
    // hide mega menu item
    let currentMenuItems = document.querySelectorAll('.' + this.classes.currentItem);
    if (currentMenuItems) {
      for (var i=0; i < currentMenuItems.length; i++) {
        let currentMenuItem = currentMenuItems[i];
        currentMenuItem.classList.remove(this.classes.currentItem);
      }
    };

    let visibleMenuItems = document.querySelectorAll('.' + this.classes.visible);
    if (visibleMenuItems) {

      for (var i=0; i < visibleMenuItems.length; i++) {
        let visibleMenuItem = visibleMenuItems[i];
        visibleMenuItem.classList.remove(this.classes.visible);
      }
    };
  }

  menuIsVisible() {
    return (document.body.classList.contains(this.classes.animate)) ? true : false;
  }

  // Event Listeners
  windowEventScroll() {
    window.addEventListener('scroll', () => {
      this.hideAllMenuItems();
      this.removeActiveClasses();
    })
  }
}

window.customElements.define("mega-menu", MegaMenu);

class MegaMenuCurtain extends MegaMenu {
  curtainTarget = 'mega-menu-curtain';

  constructor() {
    super();
  }

  connectedCallback() {
    this.curtainEventClick();
    this.curtainEventMouseover();
  }

  disconnectedCallback() {
  }

  curtainEventClick() {
    this.addEventListener('click', () => {
      this.hideAllMenuItems();
      this.removeActiveClasses();
    });
  }

  curtainEventMouseover() {
    this.addEventListener('mouseover', () => {
      if (!this.menuIsVisible()) {
        return;
      }

      this.removeActiveClasses();
      this.closeMegaMenu();
      setTimeout(() => {
        this.hideAllMenuItems();
      }, 100);
      clearTimeout(this.timer);
    });
  }
}

class MegaMenuToggle extends MegaMenu {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleClickEvent();
  }

  disconnectedCallback() {
  }

  getFirstMegaMenuItem() {
    // returns first megamenu item element
    return document.querySelector('#megamenu > mega-menu-item:first-of-type');
  }

  handleClickEvent() {
    this.addEventListener('click', () => {
      let megaMenuItemEl = this.getFirstMegaMenuItem();

      this.classList.toggle('active');
      if (!this.menuIsVisible()) {
        this.showMegaMenuItem(true, megaMenuItemEl);
        this.openMegaMenu();
      } else {
        this.hideAllMenuItems();
        this.removeActiveClasses();
        this.closeMegaMenu();
      }
    });
  }
}

class MegaMenuMainNav extends MegaMenu {

  constructor() {
    super();
  }

  connectedCallback() {
    // get links
    this.links = this.querySelectorAll('a');

    for (var i=0; i < this.links.length; i++) {
      let link = this.links[i];
      this.handleEventLinkMouseover(link);
      this.handleEventLinkMouseout(link);
    }
  }

  disconnectedCallback() {
  }

  handleEventLinkMouseover(el) {
    el.addEventListener('mouseover', () => {
      this.showMegaMenuItem(el);
    });
  }

  handleEventLinkMouseout(el) {
    el.addEventListener('mouseout', () => {

      //clearTimeout(this.timer);
    });
  }
}

window.customElements.define('mega-menu-curtain', MegaMenuCurtain);
window.customElements.define('mega-menu-toggle', MegaMenuToggle);
window.customElements.define('mega-menu-nav', MegaMenuMainNav);
